import { styled } from '@bob/library'
import { SmileyMenu } from '@websrc/App/Components/SmileyMenu/SmileyMenu'
import { themeVars } from 'leds'

export const StyledHoverMenu = styled(SmileyMenu)`
  .flyout-wrapper {
    right: -16px;
    left: auto;
  }
  .flyout-button {
    padding: 10px;
    height: 44px;
  }
  svg {
    width: 24px;
    height: 24px;
  }
  &:hover {
    path {
      stroke: ${themeVars.color.blue6} !important;
    }
  }
`
